import { ChangeEvent, useState } from "react";
import CustomInput from "../CustomInput";
import CustomButton from "../CustomButton";
import { toast } from "react-toastify";
import { ParseErrors } from "../../utils/ParseErrors";
import axiosInstance from "../../utils/axiosInstance";
import Loader from "../Loader";

interface TResetForm {
  HandleFlip: () => void;
}

const Resetform = ({ HandleFlip }: TResetForm) => {
  const [values, setValues] = useState({
    email: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const HandleForgotPassword = async () => {
    if (!Validate()) return;

    setIsLoading(true);
    try {
      await axiosInstance.post("/auth/forgot-password", values);
      toast.success("Reset link sent to your email");
    } catch (error) {
      toast.error(ParseErrors(error));
    } finally {
      setIsLoading(false);
    }
  };

  const Validate = () => {
    if (!values.email) {
      toast.error("Please enter a valid email");
      return false;
    }
    return true;
  };

  const onChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="absolute inset-0 rounded-2xl border border-[#E4EBF5] bg-white px-5 py-8 shadow-[0_20px_50px_rgba(21,44,85,0.08)] [transform:rotateY(180deg)] [backface-visibility:hidden] sm:px-10 sm:py-10">
      <div className="mb-8 text-center">
        <h2 className="font-[Gilroy-Bold] text-[26px] text-[#152C55]">
          Forgot password
        </h2>
        <p className="mt-2 font-[Gilroy-Medium] text-[14px] text-[#6B7C99]">
          We’ll email you a reset link
        </p>
      </div>

      <div className="space-y-5">
        <CustomInput
          title="Email"
          label="Email"
          name="email"
          type="email"
          onChange={onChangeValues}
          className="!h-[48px] !rounded-xl !border-[#E4EBF5] !bg-[#F7F9FC] focus:!border-[#1562EE] focus:!bg-white"
        />

        <CustomButton
          variant="primary"
          fullWidth
          disabled={isLoading}
          className="!mt-6 !h-[50px] !rounded-xl !border-none !bg-[#1562EE] !text-[15px] !font-[Gilroy-Medium] hover:!bg-[#1254CC]"
          onClick={HandleForgotPassword}
        >
          {isLoading ? <Loader /> : "Send reset link"}
        </CustomButton>

        <p
          className="cursor-pointer text-center font-[Gilroy-Medium] text-[14px] text-[#1562EE] transition-colors hover:text-[#0F4FBF]"
          onClick={HandleFlip}
        >
          Back to sign in
        </p>
      </div>
    </div>
  );
};

export default Resetform;
